import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const dialogStyling: {
  wrapper: AbgSxProps;
  divider: AbgSxProps;
  actions: AbgSxProps;
  closeWrapper: AbgSxProps;
  closeIcon: AbgSxProps;
  title: AbgSxProps;
  content: AbgSxProps;
  description: AbgSxProps;
  disclaimer: AbgSxProps;
  button: AbgSxProps;
} = {
  wrapper: {
    zIndex: 1301,
    '& .MuiDialog-container': {
      justifyContent: {
        sm: 'center',
        xs: 'flex-end',
      },
      alignItems: {
        sm: 'center',
        xs: 'flex-end',
      },
    },
    '& .MuiDialog-paper': {
      width: {
        sm: '432px',
        xs: '100%',
      },
      paddingBottom: '16px',
      margin: {
        sm: 2,
        xs: 0,
      },
    },
  },
  title: {
    color: paletteBase.black,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: {
      sm: '24px 24px 20px 24px',
      xs: '16px',
    },
  },
  closeWrapper: {
    padding: '4px 0',
  },
  closeIcon: {
    width: '16px',
    height: '16px',
  },
  divider: (theme) => ({
    height: '1px',
    background: theme.palette.stroke.lowContrast,
    border: 'none',
  }),
  content: {
    margin: 0,
    padding: {
      sm: '24px',
      xs: '16px',
    },
    '& span': {
      color: paletteBase.red500,
    },
  },
  actions: {
    padding: '9px 24px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  description: (theme) => ({
    marginTop: 0,
    color: theme.palette.neutral[500],
  }),
  disclaimer: {
    marginTop: 0,
    color: paletteBase.secondary400,
    padding: '0 24px 12px 24px',
  },
  button: {
    flexGrow: 1,
  },
};
